import axios from 'lib/axios';
import { getAccessToken, isUserAuthenticated, msalInstance } from 'lib/msal';
import { queryClient } from 'lib/query-client';

export interface AuthParams {
  email: string;
  password: string;
}

export interface ForgotPasswordParams {
  email: string;
}

export interface UpdateProfileParams {
  name: string;
}

export interface RecoverPasswordParams {
  email: string;
  newPasswordToken: string;
  newPassword: string;
}

export interface ChangePasswordParams {
  currentPassword: string;
  newPassword: string;
}

export interface ValidatePasswordTokenParams {
  email: string;
  newPasswordToken: string;
}

export interface PasswordChangeParams {
  password: string;
  oldPassword: string;
  email: string;
}

type User = object;
type AcessToken = string;

export interface AuthData {
  accessToken: AcessToken;
  user: User;
}

export const AUTH_USER_STORAGE_KEY = 'authUser';

export const AUTH_ACCESS_TOKEN_STORAGE_KEY = 'authToken';

export class AuthRepository {
  async updateProfile({ name }: UpdateProfileParams): Promise<unknown> {
    const { data: user } = await axios.patch('/auth/update-profile', { name });
    await this.invalidateAuthenticatedUserCache();
    return user;
  }

  async logout() {
    await msalInstance.logoutRedirect({ postLogoutRedirectUri: '/login' });
  }

  async logoutWithoutRedirect() {
    await msalInstance.clearCache();
  }

  async invalidateAuthenticatedUserCache() {
    await queryClient.invalidateQueries({ queryKey: ['authenticatedUser'] });
  }

  async getAuthenticatedUser() {
    if (await isUserAuthenticated()) {
      const { data: user } = await axios.get('/auth/validate');
      return user;
    }

    return null;
  }

  async getAuthenticatedUserToken() {
    return await getAccessToken();
  }
}
